export const focusRingSizes = {
   DoubleExtraLarge: {
      borderRadius: 'rounded-12px'
   },
   ExtraLarge: {
      borderRadius: 'rounded-10px'
   },
   Large: {
      borderRadius: 'rounded-10px'
   },
   Medium: {
      borderRadius: 'rounded-10px'
   },
   Small: {
      borderRadius: 'rounded-8px'
   },
   ExtraSmall: {
      borderRadius: 'rounded-8px'
   }
}
